import { BASE_API } from "../Config/Config";
import { authenticatedFetch } from "./fetchprivateapi";

export const fetchgalleryapi = async () => {
    try {
        const response = await authenticatedFetch(`${BASE_API}/apis/getgallery.php`, {
            method: "GET",
        });

        // if (!response) return;
        if (!response) return [];

        const result = await response.json();

        if (result.status === true) {
            return result.collections;
        }
        return [];

    } catch (error) {
        console.error("Fetch Gallery Error:", error);
        return [];
    }
};

// import { BASE_API } from "../Config/Config";

// export const fetchgalleryapi = async () => {
//     try {
//         const response = await fetch(`${BASE_API}/apis/getgallery.php`, {
//             method: "GET",
//             credentials: "include"
//         });

//         const result = await response.json();

//         if (result.status === true) {
//             return result.collections;
//         } else {
//             return [];
//         }
//     } catch (error) {
//         console.error("Fetch Gallery Error:", error);
//         return [];
//     }
// };